/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericTableResponse } from '../../models/generic-table-response';

export interface GetDeliveredCases$Params {

/**
 * The from date
 */
  from?: string;

/**
 * The to date
 */
  to?: string;
}

export function getDeliveredCases(http: HttpClient, rootUrl: string, params?: GetDeliveredCases$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeliveredCases.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {"style":"form","explode":true});
    rb.query('to', params.to, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenericTableResponse>;
    })
  );
}

getDeliveredCases.PATH = '/api/v1/statistics-dashboard/delivered_cases';
